import type { OfflineManifest } from '@floorfile/contracts'

/**
 * The client-side D24 manifest registry (doc §11): each feature slice
 * registers its owner declaration at app start; the offline runtime uses
 * them to gate caching (`neverCache` — HR PII never enters IndexedDB) and
 * the sync center uses them to label module coverage.
 */

const manifests = new Map<string, OfflineManifest>()

export function registerOfflineManifest(manifest: OfflineManifest): void {
  manifests.set(manifest.module, manifest)
}

export function getOfflineManifest(module: string): OfflineManifest | undefined {
  return manifests.get(module)
}

export function allOfflineManifests(): OfflineManifest[] {
  return [...manifests.values()].sort((a, b) => a.module.localeCompare(b.module))
}

/** The hard D24 gate: nothing from a never-cache module may be stored. */
export function isCacheable(module: string): boolean {
  return manifests.get(module)?.neverCache !== true
}
